import styled from 'styled-components';
export const FareContent = styled.div`
  background: #fff;
  width: 100%;
  overflow-x: auto;
  border-radius: 10px;
`;

export const Book = styled.div`
  font-size: 1.4rem;
  line-height: 1.33;
  padding: 8px 8px;
  background: #f26722;
  color: #fff;
  border-radius: 5px;
`;
export const FareWrap = styled.div`
  width: 100%;
  overflow-x: auto;
  padding: ${props => (props.isDweb ? '1rem 0' : '1rem')};
  table {
    border: 1px solid #d8eaff;
    width: 100%;
  }
  th {
    background: #fff;
    border-color: #e4e4e4;
    border-width: 0 1px 0 0;
    font-size: 11px;
    color: #666;
    padding: 15px;
    width: 30%;
    text-transform: uppercase;
    border-bottom: solid 1px #e8e8e8;
    text-align: left;
  }
  td {
    border-color: #e4e4e4;
    border-width: 1px 1px 0 0;
    font-weight: 400;
    width: 30%;
    white-space: nowrap;
    padding: 10px !important;
    border-bottom: solid 1px #e8e8e8;
  }
  a {
    color: #166bd3;
    cursor: pointer;
    outline: none;
    text-decoration: none;
    /* min-height: 48px; */
    padding: 17px 0;
  }
  .hit {
    color: #166bd3;
    cursor: pointer;
    outline: none;
    text-decoration: none;
    /* min-height: 48px; */
    /* padding: 17px 0; */
  }
`;
